<template>
  <div class="fe-radio">
    <el-form-item
      :label="endTitle | capitalize"
      :class="{ 'form-group--error': $v.defaultValue.$error, 'is-required': isRequired }"
    >
      <el-radio-group
        v-model="defaultValue"
        class="fe-radio-content"
        @change="dealData"
        :disabled="disabled"
      >
        <el-radio  v-for="item in options" :label="item.value" :key="item.value">{{item.label}}</el-radio>
      </el-radio-group>
      <div
        class="el-form-item__error error_input"
        v-if="inForm && $v.defaultValue.$error"
      >{{errorMessage}}
      </div>
    </el-form-item>
  </div>
</template>
<script>
  // import _ from 'lodash'
/* eslint-disable */
  import validateMixin from '../../mixins/validateMixin'
  import baseMixin from './mixin/base'
  export default {
    name: 'fe-radio',
    mixins: [validateMixin, baseMixin],
    props: {
      options: Array,
      value: {
        type: String | Boolean
      }
    },
    data() {
      return {
        defaultValue: ''
      }
    },
    watch: {
      value: {
        handler(val) {
          if (val) {
            this.defaultValue = val
          } else {
            this.defaultValue = ''
          }
        },
        deep: true,
        immediate: true
      },
      defaultValue(val) {
        // this.$emit('input', val)
      }
    },
    methods: {
      dealData() {
        this.$emit('input', this.defaultValue)
        this.$nextTick(() => {
          this.triggerVaildate()
        })
      }
    }
  }
</script>
<style type="text/scss" lang="scss" scoped>
  .fe-radio {

  }
</style>



// WEBPACK FOOTER //
// src/components/FromBase/radio.vue